import { render, staticRenderFns } from "./AuditLogBox.vue?vue&type=template&id=95f6fd76&"
import script from "./AuditLogBox.vue?vue&type=script&lang=js&"
export * from "./AuditLogBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95f6fd76')) {
      api.createRecord('95f6fd76', component.options)
    } else {
      api.reload('95f6fd76', component.options)
    }
    module.hot.accept("./AuditLogBox.vue?vue&type=template&id=95f6fd76&", function () {
      api.rerender('95f6fd76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/AuditLogBox.vue"
export default component.exports